import { createFileRoute } from '@tanstack/react-router'
import { AppraisalsPage } from '@/features/employee-portal/pages/AppraisalsPage'

export const Route = createFileRoute('/employee/appraisals/')({
  component: AppraisalsPage,
})
